import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-76" data-mp="16m0vlgnh87es">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="1bjiyapawhqec">
        <div className="flex justify-center" data-id="element-78" data-mp="1bi7skjxwa8kl">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-ivory" data-id="element-79" data-mp="wms5iyvqfcxp">
            <GiftIcon className="h-5 w-5 text-brand-rosewood" strokeWidth={1.5} aria-hidden="true" data-id="element-80" data-mp="11mehz63qkp5g" />
          </span>
        </div>
        <SectionHeading id="bonuses-heading" title={<>
              E non è tutto: <Accent data-id="element-82" data-mp="slq4qdm62stm">ricevi anche 5 bonus didattici!</Accent>
            </>} className="mt-5" data-id="element-81" data-mp="nny0ck4c5e8j" />

        <ol className="mt-12 grid gap-6 md:grid-cols-2" role="list" data-id="element-83" data-mp="2hyjvszfkqgn1">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(120,70,80,0.4)] ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-84" data-mp="1k7lq9zlwh6i0" data-mpi={index}>
              <div className="px-6 py-3" style={{
            backgroundColor: bonus.accent
          }} data-id="element-85" data-mp="1oyk9b6y9wioy">
                <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-86" data-mp="1p0n74d5o3g48">
                  {bonus.number}
                </p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-87" data-mp="x97dhz5p0t4i">
                <h3 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-88" data-mp="1b86zez1tmtwz">{bonus.title}</h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-89" data-mp="166hr3r5zgucl">{bonus.description}</p>
                <p className="mt-auto flex items-center gap-1.5 self-start pt-5 font-body text-[11px] font-bold uppercase tracking-[0.14em] text-brand-cta" data-id="element-90" data-mp="2mof87i7uj1h3">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-91" data-mp="2pop5o9lzt9ic" />
                  Inclusi nel sistema
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-92" data-mp="2ypn6kj14x0wp">
          Riferimenti visivi. Moduli. Casi pratici. Manuale. Presentazioni.{' '}
          <Accent data-id="element-93" data-mp="261rbtjv4lj2k">Già pronti per te.</Accent>
        </p>
      </div>
    </section>;
}